import { createReducer, on, Action } from '@ngrx/store';
import { IMenuItem } from '../../../models/menu-items';
import { NavigationUiActions } from '../actions';
import { DashboardRegistration } from '../../../../views/dashboard/dashboard-registration';

const initialState: NavigationDataState = {
  toggleNav: true,
  sideNavMenuItems: DashboardRegistration.getMenu(),
  selectedItemState: null,
};

export interface NavigationDataState {
  toggleNav: boolean;
  sideNavMenuItems: IMenuItem[];
  selectedItemState: string | null;
}

export const NavigationDataStateReducer = createReducer(
  initialState,
  on(NavigationUiActions.ToggleNav, (state) => {
    return {
      ...state,
      toggleNav: !state.toggleNav,
    };
  }),
  on(NavigationUiActions.SetSideNavMenuItems, (state, { sideNavMenuItems }) => {
    return {
      ...state,
      sideNavMenuItems: sideNavMenuItems,
    };
  }),

  on(NavigationUiActions.SetSelectedItem, (state, { selectedItemState }) => {
    return { ...state, selectedItemState };
  })
);

export function NavigationReducer(state: NavigationDataState = initialState, action: Action): NavigationDataState {
  return NavigationDataStateReducer(state, action);
}
